import React from "react";
import { Email, Facebook, Instagram, LinkedIn, X } from "@mui/icons-material";
import logo from "../assets/full-image.png";
import image from "../assets/images/coin.jpg";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="relative text-white overflow-hidden font-serif"
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-black/70 z-0"></div>

      <div className="max-w-7xl mx-auto px-4 lg:px-10 py-12 z-20 relative">
        <div className="flex flex-col md:flex-row justify-between items-start gap-12 border-b border-gray-700 pb-10">
          {/* Logo and Quick Links */}
          <div className="flex flex-col gap-6">
            <Link to="/" className="inline-flex items-center w-fit">
              <img
                src={logo}
                alt="Harvit Logo"
                className="h-16 md:h-20 w-auto object-contain rounded-md bg-amber-50 px-3 py-2"
              />
            </Link>

            <div>
              <h3 className="text-lg font-medium mb-2">Quick Links:</h3>
              <ul className="space-y-1 text-amber-500 list-disc pl-4">
                <li className="hover:opacity-70">
                  <Link to="/">Home</Link>
                </li>
                <li className="hover:opacity-70">
                  <Link to="/about-us">About Us</Link>
                </li>
                <li className="hover:opacity-70">
                  <Link to="/contact-us">Contact us</Link>
                </li>
                <li className="hover:opacity-70">
                  <Link to="/faqs">Frequently Asked Questions</Link>
                </li>
                <li className="hover:opacity-70">
                  <Link to="/apply-loan">Apply For A Loan</Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Social Media */}
          <div className="flex flex-col gap-4 md:items-end">
            <h3 className="text-lg font-medium">Connect With Us:</h3>
            <div className="flex gap-3">
              <a
                href="#"
                aria-label="Email"
                className="bg-blue-900 p-2 rounded hover:bg-amber-500 transition-colors"
              >
                <Email />
              </a>
              <a
                href="#"
                aria-label="Facebook"
                className="bg-blue-900 p-2 rounded hover:bg-amber-500 transition-colors"
              >
                <Facebook />
              </a>
              <a
                href="#"
                aria-label="Instagram"
                className="bg-blue-900 p-2 rounded hover:bg-amber-500 transition-colors"
              >
                <Instagram />
              </a>
              <a
                href="#"
                aria-label="LinkedIn"
                className="bg-blue-900 p-2 rounded hover:bg-amber-500 transition-colors"
              >
                <LinkedIn />
              </a>
              <a
                href="#"
                aria-label="X (Twitter)"
                className="bg-blue-900 p-2 rounded hover:bg-amber-500 transition-colors"
              >
                <X />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="text-sm text-white mt-8 flex flex-col md:flex-row justify-between items-center gap-3">
          <p>
            Copyright Bunda Investment {currentYear} | All rights reserved |
            Site by{" "}
            <Link
              to="https://www.linkedin.com/in/george-mwangi-47057215b/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="George Mwangi LinkedIn Profile"
              className="text-amber-500 hover:underline"
            >
              George
            </Link>
          </p>
          <p className="flex gap-4">
            <a
              href="/terms-and-conditions"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              Terms of use
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
